import { useDispatch, useSelector } from "react-redux"
import { ApplicationState } from "../../interface/ApplicationState"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import { updateLocalUser } from "../../redux/actions/userActions"
import { getAllTypes } from "../../const"
import { alpha, useTheme } from "@mui/material/styles"



export const IntervalSelector = () =>
{
  const theme = useTheme()
  const dispatch = useDispatch()
  const chartInterval = useSelector((state: ApplicationState) => state.userStore.user.chartInterval)

    return(
      <Select
        size="small"
        sx={styles.select(theme)}
        value={chartInterval || "1m"}
        onChange={(e: any) => dispatch(updateLocalUser({ chartInterval: e.target.value }))}
      >
          {getAllTypes().map((interval, key) => <MenuItem value={interval} key={key}>{interval}</MenuItem>)}
      </Select>
    )


}

const styles = {
  select: (theme: any) => ({
    mr: 2,
    minWidth: 92,
    color: theme.palette.text.primary,
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.04 : 0.72),
    borderRadius: "16px",
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.42),
    },
    '& .MuiSelect-icon': {
      color: alpha(theme.palette.text.primary, 0.72),
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: alpha(theme.palette.primary.main, theme.palette.mode === "dark" ? 0.5 : 0.55),
    },
  }),
}
